// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3zpuh","title":"Header_title__3ghy6","left":"Header_left__1Be8l","clinicName":"Header_clinicName__10X6P"};